module.exports = __webpack_public_path__ + "static/1-min-240a154382c2ae9f5ff76d0062e646d9.jpg";